import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { FuelsCollection, FuelsData } from './types';

const KEY = ['ref-production-fuels'];
const ENDPOINT = '/api/ref-production-fuels';

async function requestData(url: string, init?: RequestInit): Promise<FuelsData> {
    const response = await fetch(url, init);
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.message ?? `Les combustibles n'ont pas pu être chargés ou modifiés (${response.status}).`);
    }
    return response.json();
}

const json = (method: string, body?: unknown): RequestInit => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
});

export function useFuels() {
    return useQuery({ queryKey: KEY, queryFn: () => requestData(ENDPOINT) });
}

type Mutation =
    | { kind: 'create'; collection: FuelsCollection; input: object }
    | { kind: 'update'; collection: FuelsCollection; id: string; patch: object }
    | { kind: 'delete'; collection: FuelsCollection; id: string };

export function useFuelsMutation() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: (mutation: Mutation) => {
            if (mutation.kind === 'create') return requestData(`${ENDPOINT}/${mutation.collection}`, json('POST', mutation.input));
            if (mutation.kind === 'update') return requestData(`${ENDPOINT}/${mutation.collection}/${mutation.id}`, json('PATCH', mutation.patch));
            return requestData(`${ENDPOINT}/${mutation.collection}/${mutation.id}`, json('DELETE'));
        },
        onSuccess: (data) => client.setQueryData(KEY, data),
        onSettled: () => client.invalidateQueries({ queryKey: KEY }),
    });
}
